import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiShopService } from '../../../../services/shop/api/api-shop.service';
import { ShopService } from '../../../../services/shop/shop.service';
import { AlertsService } from '../../../../services/alerts.service';
import { LanguagesService } from '../../../../services/languages/languages.service';
import { ShopPackTranslation } from '../../../../models/shop/shop-pack-translation.model';
import { ShopPackReward } from '../../../../models/shop/shop-pack-reward.model';
import { ShopPackBooster } from '../../../../models/shop/shop-pack-booster.model';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';
import { UserBoosterType } from '../../../../enums/users/user-booster-type.enum';

interface TranslationForm {
  languageId: number;
  languageIso: string;
  title: string;
  description: string;
  isCollapsed: boolean;
}

@Component({
  selector: 'app-shop-pack-add-modal',
  templateUrl: './shop-pack-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class ShopPackAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  name: string = '';
  startDate: string = '';
  endDate: string = '';
  shopItemId: number = 0;
  translations: TranslationForm[] = [];
  rewards: ShopPackReward[] = [];
  boosters: ShopPackBooster[] = [];

  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];
  readonly boosterTypes = Object.entries(UserBoosterType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(
    private apiShopService: ApiShopService,
    public shopService: ShopService,
    public languagesService: LanguagesService,
    private alertsService: AlertsService
  ) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.name = '';
    this.startDate = '';
    this.endDate = '';
    this.shopItemId = 0;
    this.rewards = [];
    this.boosters = [];
    this.isLoading = false;
    this.translations = this.languagesService.languages.map(l => ({
      languageId: l.languageId,
      languageIso: l.languageIso,
      title: '',
      description: '',
      isCollapsed: true
    }));
    this.modal.show();
  }

  toggleTranslation(t: TranslationForm): void { t.isCollapsed = !t.isCollapsed; }
  addReward(): void { this.rewards.push(new ShopPackReward()); }
  removeReward(i: number): void { this.rewards.splice(i, 1); }
  addBooster(): void { this.boosters.push(new ShopPackBooster()); }
  removeBooster(i: number): void { this.boosters.splice(i, 1); }

  save(): void {
    this.isLoading = true;
    const startTimestamp = this.startDate ? Math.floor(new Date(this.startDate + 'Z').getTime() / 1000) : 0;
    const endTimestamp = this.endDate ? Math.floor(new Date(this.endDate + 'Z').getTime() / 1000) : 0;
    const translationsPayload = this.translations.map(t => { const tr = new ShopPackTranslation(); tr.languageId = t.languageId; tr.title = t.title; tr.description = t.description; return tr; });

    this.apiShopService.addPack(this.name, startTimestamp, endTimestamp, this.shopItemId, translationsPayload, this.rewards, this.boosters).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Pack added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding pack : ' + error);
      }
    );
  }
}
